module.exports = __webpack_public_path__ + "static/UPCOMING-eb3365b83fd7d557583c83b9eb90a1fd.svg";